import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { ModelOption } from '../../../../../types';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../../types/NonPaginatedResponse';
import { USER_BASE_PATH } from '../../constants/userBasePath';
import { getUserOptions } from '../../requests/getUserOptions';

export const useUserOptions = (
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    NonPaginatedResponse<ModelOption[]> | undefined
  >({
    queryKey: [USER_BASE_PATH, 'options', params],
    queryFn: () => getUserOptions(constructGet, params),
    ...options,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'userOptions'),
    ...rest,
  };
};
